import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';

// eslint-disable-next-line require-await
export default [
  {
    // Client Segment Setting
    path: '/advisor/segments',
    name: 'ClientSegments',
    component: () => import('@advisor/components/settings/SegmentSetting'),
    meta: {
      breadCrumbs: {
        to: '',
        text: 'Settings',
        title: 'Client Segmentation',
        componentId: COMPONENT_ID.CLIENT_SEGMENTS,
      },
      platformArea: PLATFORM_AREA.CLIENT_SEGMENTS,
      riaComponent: RIA_COMPONENT.CLIENT_SEGMENTS,
      visibilityComponentId: COMPONENT_ID.CLIENT_SEGMENTS,
    },
  },
  {
    // Client Segment Setting
    path: '/advisor/segments/:segmentId?',
    name: 'SegmentSettings',
    component: () => import('@advisor/components/settings/clientSegment/SegmentDetails'),
    meta: {
      breadCrumbs: {
        to: '',
        text: 'Settings',
        title: 'Client Segmentation',
        componentId: COMPONENT_ID.CLIENT_SEGMENTS,
      },
      platformArea: PLATFORM_AREA.CLIENT_SEGMENTS,
      riaComponent: RIA_COMPONENT.CLIENT_SEGMENTS,
      visibilityComponentId: COMPONENT_ID.CLIENT_SEGMENTS,
    },
  },
];
